<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: Array,
    options: Array,
    color: String,
  },
  created() {},
  mounted() {
    this.renderChart(
      {
        // labels: this.options,
        labels: ["niasdasd", "dasdasd", "asda", "ddddd"],
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(20,153,242,.0)",
            // data: this.chartdata,
            data: [10, 12, 12, 13],
            borderWidth: 3,
            borderColor: this.color,
            pointRadius: 0,
          },
        ],
      },
      {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          align: "start",
          display: true,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                display: true,
              },
            },
          ],
        },
      }
    );
  },
};
</script>

<style>
</style>